module.exports = __webpack_public_path__ + "static/media/social_facebook.8f330e90.svg";